import { I18n } from "react-i18nify";

let i18nUtils = {
	initTranslation: (language, locales) => {
		let translation = {};
		translation[language] = locales;

		I18n.setTranslations(translation);
		I18n.setLocale(language);

		I18n.setHandleMissingTranslation(function(key) {
			return `translation ${key}`;
		});
	},

	initMockTranslation: () => {
		I18n.setTranslations({
			current: {
				"pageNotFound": "Page not found",
				"login": {
					"login": "Login",
					"username": "Username",
					"password": "Password",
					"signin": "Sign in"
				},
				"header": {
					"title": "Uploader",
					"logout": "Log out",
					"commandList": "Administrer la liste des commandes",
					"uploadDocument": "Télécharger un document"
				},
				"commandList": {
					"title": "Liste des taches",
					"folder": "Folder",
					"file": "File",
					"statusDate": "Status Date",
					"status": "Status",
					"action": "Action",
					"button": {
						"sent": "sentButton",
						"running": "runningButton"
					}
				}
			}
		});
		I18n.setLocale("current");

		I18n.setHandleMissingTranslation(function(key) {
			return `Missing translation: ${key}`;
		});
	}
};

export default i18nUtils;



// WEBPACK FOOTER //
// ./src/utils/i18n.js